var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWordless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 58,
    viewBox: "0 0 112 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_2772)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9434 29.2628L0 57.6953V29.2447L55.9434 0.812378V29.2628Z",
    fill: "#FF5F14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.887 29.281L55.9434 57.7132V29.2628L111.887 0.830444V29.281Z",
    fill: "#1A1919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_2772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 57,
    fill: "white",
    transform: "translate(0 0.713257)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWordless);
export default __webpack_public_path__ + "static/media/logoWordless.565b0561cdd780bea9bd53c8e9ef566b.svg";
export { ForwardRef as ReactComponent };